import { useTheme } from '@mui/material';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useMemo } from 'react';

export const DemReconOpenMonthProgressChart = ({ data }) => {

  const { navigateTo } = useNavState();

  const centerSubLabel = useMemo(() => {
    if (!data) return null;

    const totalCount = data.totalCount;
    const completedCount = data.reconciledCount + data.matchingCount;

    const pct = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;
    return `${pct.toFixed(1)}% Matching`;
  }, [data])

  const theme = useTheme();

  const green = theme.palette.success.main;
  const lightGreen = theme.palette.success.light;
  const red = theme.palette.error.main;

  const handleClick = (clickData) => {
    navigateTo('gtn/recon', {
      mode: Mode.PERSPECTIVE,
      perspectiveState: {
        dimFilters: {
          PAID_PERIOD: [data.openPeriodId]
        }
      },
      filterButtons: {
        discrepancy: 1
      }
    } );
  }

  return (
    <PieChart
      data={[
        { label: 'No Discrepancy', value: data?.matchingCount, color: green },
        { label: 'Reconciled', value: data?.reconciledCount, color: lightGreen },
        { label: 'Outstanding', value: data?.outstandingCount, color: red },
      ]}
      centerLabel={data?.openPeriodCode}
      centerSubLabel={centerSubLabel}
      onClick={handleClick}
    />
  );
};
